import subShop from '../subshop/rbmc.subShop.js';
import mobileNavigation from '../navigation/rbmc.mobileNavigation';
import subShopNavigation from '../navigation/rbmc.subShopNavigation';
import subshopNavigation from '../rbmc.subshop-selector';
import cartTooltip from "../cart/rbmc.cart-tooltip";

const navigation = {
    $body:        undefined,
    $pageContent: undefined,
    newCLickEvt:  new Event("click", {"bubbles": true, "cancelable": false}),

    cacheSelectors() {
        this.$body        = $('body');
        this.$pageContent = this.$body.find('.page-content');
    },
    /**
     * @deprecated
     */
    handleSubShopIndication() {
        subShop.handleSubShopIndication();
    },
    /**
     * @deprecated
     */
    handleSubShopSpecificNavigation() {
        subShopNavigation.handleNavigation();
    },
    /**
     * @deprecated
     */
    handleMobileNavigation() {
        mobileNavigation.mobileMenuNavigation();
        mobileNavigation.mobileMenuOpenClose();
    },

    handleNavigationItemHover() {
        const delayTimeForNavigation = 350;
        let entranceTimeout          = undefined;
        navigation.$body.on('mouseenter', '.page-header__main-nav-list', () => {
            clearTimeout(entranceTimeout);
            entranceTimeout = setTimeout(function () {
                navigation.setGreyout(true);
            }, delayTimeForNavigation)
        });
        navigation.$body.on('mouseleave', '.page-header__main-nav-list', () => {
            if (!cartTooltip.cartOpen) {
                clearTimeout(entranceTimeout);
                entranceTimeout = setTimeout(function () {
                    navigation.setGreyout(false);
                }, delayTimeForNavigation)
            }
        });
    },

    //set or remove grey out effect on site content wrapper
    setGreyout(state) {
        if (state) {
            navigation.$pageContent.addClass('page--greyout');
        } else {
            navigation.$pageContent.removeClass('page--greyout');
        }
    },

    bindSelfClick() { // Archibald support
        navigation.$body.on('click', '.page--greyout', () => {
            navigation.setGreyout(false);

            // Trigger click for React -> close menu programatically
            const closeButton = document.querySelector('.CMSMobileCategoryNavigationComponent .MenuButton__closeIcon');
            closeButton ? closeButton.dispatchEvent(navigation.newCLickEvt) : false;
        });
    },

    //handle navigation elements visibility in case of changing breakpoint
    /**
     * @deprecated
     */
    handleElementsOverBreakpoints() {
        Breakpoints.on('desktop', {
            leave: () => {
                subshopNavigation.close();
            }
        });
    }
};

$(() => {
    navigation.cacheSelectors();
    navigation.handleNavigationItemHover();
    navigation.bindSelfClick();
    if (!RedBull.config.archibaldRenderingEnabled) {
        // fetch (from backend) and show subShop specific navigation if needed
        navigation.handleSubShopSpecificNavigation();
        // set subshop cookie from subShop indication
        navigation.handleSubShopIndication();
        // bind handlers and copy banners for mobile navigation
        navigation.handleMobileNavigation();
        navigation.handleElementsOverBreakpoints();
    }
});

export default navigation;
